import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { get } from 'lodash';
import { useTranslation } from '../../../src/i18n';
import TitledBlock from '../../../components/TitledBlock';
import { TP } from '../../../constants/consts';
import { dateShowFormat } from '../../../utils/common';
import Title from '../../../components/Title';
import { performanceInfo } from './TimeSelectCard';

const useStyles = makeStyles(theme => ({
  cardInfo: {
    display: 'flex',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
}));

const liveEventTitles = [
  {
    value: 'time',
    title: `${TP}.FN_TIME`,
  },
  {
    value: 'date',
    title: `${TP}.m_DATE`,
  },
  {
    value: 'timezone.name',
    title: `${TP}.REGISTRATION_TIME_ZONE`,
  },
  ...performanceInfo,
];

const DigitalPresenceLiveEventInfo = ({ liveEvent }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <>
      <Title>{t(`${TP}.PERFORMANCE_LIVE_EVENT`)}</Title>
      <div className={classes.cardInfo}>
        {liveEventTitles.map(info => {
          const text = get(liveEvent, info.value);
          return (
            text && (
              <TitledBlock key={info.value} title={t(info.title)}>
                {info.value === 'date' ? dateShowFormat(text) : text}
              </TitledBlock>
            )
          );
        })}
      </div>
    </>
  );
};

DigitalPresenceLiveEventInfo.propTypes = {
  liveEvent: PropTypes.object.isRequired,
};

export default DigitalPresenceLiveEventInfo;
